
import React from 'react';
import {
    krisLuk01,
    krisLuk02,
    krisLuk03,
    krisLuk04,
    krisLuk05,
    krisLuk06,
    krisLuk07,
    krisLuk08,
    krisLuk09,
    krisLuk10,
    krisLuk11,
    krisLuk12,
    krisLuk13,
    krisLuk14,
    krisLuk15,
    krisLuk16,
    krisLuk17,
    krisLuk18,
    krisLuk19,
    krisLuk20,
    krisLuk21,
    krisLuk22,
    krisLuk23,
    krisLuk24,
    krisLuk25,
    krisLuk26,
    krisLuk27,
    krisLuk28,
    krisLuk29,
    krisLuk30,
    krisLuk31,
    krisLuk32,
    krisLuk33,
    krisLuk34,
    krisLuk35,
    krisLuk36,
    krisLuk37,
    krisLuk38,
    krisLuk39,
    main,
} from '../OurCouplesPics/KrisLuk';


export const KrisAndLuk = {
    bgColor: "bgGrey",
    title: "Krystian i Łukasz - wesele dwóch żywiołów w Leśnym Dworze",
    path: "wesele-dwoch-zywiolow-w-lesnym-dworze",
    minHeight: true,
    seoTitle: "Krystian i Łukasz - wesele dwóch żywiołów w Leśnym Dworze",
    seoText: "Wesele Krystiana i Łukasza w Leśnym Dworze było połączeniem dwóch żywiołów, dwóch estetyk i jednej, całkowicie wspólnej wizji.",
    mainPic: {
        src: main
    },
    details: "Wesele Krystiana i Łukasza w Leśnym Dworze było połączeniem dwóch żywiołów, dwóch estetyk i jednej, całkowicie wspólnej wizji. To była celebracja prawdy, miłości i odwagi w najpiękniejszej formie.",
    org: "Agencja Ślubna Czary Marry",
    orgLink: "",
    place: "Leśny Dwór Sulęczyno",
    placeLink: "",
    decor: "Gabi Prządka",
    decorLink: "",
    photo: "Paulina Pietraszkiewicz",
    photoLink: "",
    music: "Cocons Club",
    musicLink: "",
    movie: "Lynx Creatives",
    movieLink: "",
    date: "27 gru 2025",
    textMain:
        'Od pierwszego spotkania z Krystianem i Łukaszem wiedziałyśmy, że ich ślub nie będzie kolejną standardową realizacją. Oni chcieli czegoś więcej niż pięknych dekoracji i dobrego planu. Szukali historii, która odda ich osobowości, kontrasty i to, jak pięknie się uzupełniają. Krystian jest spokojem, harmonią, analitycznym umysłem i minimalistyczną estetyką. Łukasz wnosi dynamikę, emocje, ekspresję i odwagę. Dwa światy, dwa żywioły, jedno "my".',
    topPic: { src: main },
    content: [
        {
            headerSmall: 'Krystian i Łukasz – ECSTASY - Połączenie dwóch żywiołów.',
            headerClassName: "grey",
            text: <><p>Z tej różnorodności narodził się projekt <span className='grey bold'>ECSTASY</span> - koncepcja oparta na symbolice układu krwionośnego. Dekoracje swoją strukturą przypominały sieć naczyń krwionośnych, których źródłem było „serce” sali: stół pary młodej. Było to subtelne, ale znaczące nawiązanie do profesji Krystiana, który jest kardiologiem. Czerwień, pojawiająca się w przestrzeni w intensywnych, energicznych akcentach, pełniła jednak także drugą rolę - symbolizowała temperament i ekspresję Łukasza, eksplodując niczym życiodajny impuls. Z kolei monochromatyczne, szare dekoracje odzwierciedlały spokój i równowagę Krystiana. Razem stworzyły opowieść, która mówiła o ich relacji więcej niż jakiekolwiek słowa.</p>
                <p>Nie sposób pominąć światła, które w tym projekcie było kluczowym elementem, nadając dekoracjom blasku, głębi i dramaturgii. Zastosowaliśmy oświetlenie architektoniczne, harmonijnie podkreślające zarówno charakter wnętrza sali, jak i aranżacje ceremonii świetlnej. W tym projekcie wszystko współgrało - kompozycje kwiatowe, zastawa, papeteria, światło i proporcje. Każdy detal miał swoje znaczenie, a nic nie znalazło się tu przypadkowo.</p>
                <p>Tak powstała realizacja, która stała się nie tylko dekoracją, lecz spójną, żywą historią o dwóch sercach bijących w jednym rytmie.</p></>,
            pics: [
                { src: krisLuk01 },
                { src: krisLuk02 },
                { src: krisLuk03 },
                { src: krisLuk04 },
                { src: krisLuk05 },
                { src: krisLuk06 },
                { src: krisLuk07 },
                { src: krisLuk08 },
                { src: krisLuk09 },
                { src: krisLuk10 },
                { src: krisLuk11 },
                { src: krisLuk12 },
                { src: krisLuk13 },
            ]
        },
        {
            headerSmall: "Leśny Dwór – przestrzeń zanurzona w naturze",
            headerClassName: "grey",
            text: <>
                <p>
                    Samo miejsce wesela również miało ogromne znaczenie. Było to wyjątkowe przestrzeń, która pozwoliła parze młodej i ich gościom spędzić kilka dni w atmosferze relaksu, blisko natury, z czasem na integrację i celebrację. Wybrana sala nie tylko oferowała duże możliwości logistyczne, lecz także tworzyła piękne, spójne tło dla całej opowieści, którą wspólnie budowaliśmy.
                </p>
                <p>
                    Krystian i Łukasz od początku wiedzieli, że chcą rozpocząć ten dzień wspólnie - bez pośpiechu, w pełnym bliskości rytmie. Możliwość przygotowań na miejscu była dla nich ogromną wartością. Poranek upłynął im w spokojnej, intymnej atmosferze, w otoczeniu osób, które są dla nich najważniejsze. To były momenty pełne czułych gestów, autentycznych emocji i naturalnej radości, które pięknie wprowadziły ich w dalszą, już w pełni celebracyjną część dnia.ną atmosferę, która idealnie wprowadzała w dalszą część tego niezwykłego dnia.
                </p>
            </>,
            pics: [
                { src: krisLuk14 },
                { src: krisLuk15 },
                { src: krisLuk16 },
                { src: krisLuk17 },
                { src: krisLuk18 },
                { src: krisLuk19 },
                { src: krisLuk20 },
                { src: krisLuk21 },
                { src: krisLuk22 }
            ]
        },
        {
            headerSmall: "Odwrócony przebieg dnia i ceremonia po zmroku",
            headerClassName: "grey",
            text: <>
                <p>Zamiast podążać za tradycyjnym scenariuszem, przyjęcie rozpoczęło się od koktajlu w ogrodzie, a następnie uroczystego obiadu. Para pragnęła, by goście weszli w atmosferę celebracji spokojnie - przy wspólnym stole, rozmowach i swobodnym rytmie. Dopiero później nadszedł czas na pierwszy taniec i zabawę na parkiecie. Kulminacja miała jednak dopiero nadejść. Gdy zapadł zmrok, a otoczenie nabrało głębi i tajemniczości, wszyscy wyszli na zewnątrz na humanistyczną ceremonię.</p>
                <p>Ten odwrócony porządek dnia był w pełni przemyślanym wyborem. Chodziło o emocje, o subtelną, nie dosłowną magię, która po prostu nie mogłaby zaistnieć w jasnym świetle dnia. To był moment, który na długo pozostał w pamięci wszystkich obecnych.</p>
            </>,
            pics: [
                { src: krisLuk23 },
                { src: krisLuk24 },
                { src: krisLuk25 },
                { src: krisLuk26 },
                { src: krisLuk27 },
                { src: krisLuk28 },
                { src: krisLuk29 },
                { src: krisLuk30 },
                { src: krisLuk31 },
            ]
        },
        {
            headerSmall: "Wesele pełne emocji i dobrej energii",
            headerClassName: "grey",
            text: "Po ceremonii rozpoczęła się część weselna, która szybko nabrała tempa. Goście weszli w klimat intensywnych, dobrych emocji, a parkiet ani na chwilę nie stał pusty. Były tańce, rozmowy, bliskość i dużo śmiechu. Jedną z najbardziej zaskakujących atrakcji wieczoru był DR LOVE. Chłopaki wybrali go z konkretną myślą - aby wprowadzić element zabawy, interakcji i humoru. I to absolutnie zadziałało. Goście byli zachwyceni, a atrakcja idealnie wpasowała się w nieoczywisty charakter całego dnia.",
            pics: [
                { src: krisLuk32 },
                { src: krisLuk33 },
                { src: krisLuk34 },
                { src: krisLuk35 },
                { src: krisLuk36 },
                { src: krisLuk37 },
                { src: krisLuk38 },
            ]
        },
        {
            text: <>
                <p>
                    Ale to nie wszystko. Łukasz i Krystian są wyjątkową parą jednopłciową, która musiała pokonać wiele przeszkód, zanim stanęli na ślubnym kobiercu i wypowiedzieli swoje „tak”. Być może właśnie dlatego ich miłość, oddanie i emocje były tak intensywne - odczuwalne nie tylko dla nich, lecz także dla nas i wszystkich gości. Atmosfera tego dnia była absolutnie wyjątkowa, pełna wzruszeń i pięknej, prawdziwej energii.</p>
                <p>Obserwowanie, jak celebrują każdą chwilę, było dla nas ogromną przyjemnością. Ta wspólna droga - od pierwszych rozmów po dzień ślubu - stała się dla nas doświadczeniem, które zostanie w pamięci na długo.</p>
            </>,
            pics: [
                { src: krisLuk39 }
            ]
        },
    ],
}